var rtl = false;
if(document.dir == 'rtl')
  rtl = true;
$('.list-mostpopulare-link').click(function(){
    var val = $(this).text();
    $('.search-input [name="q"]').val(val).trigger('change');
});
$(document).ready(function() {
    var scrollAmount = 100; // Adjust this value based on your requirement
    var animationSpeed = 200;
    // Function to check the state of the scroll and toggle the disabled attribute of buttons
    function checkScroll($container) {
        var $prevButton = $container.find('.mrk-prev-slider-btn button');
        var $nextButton = $container.find('.mrk-next-slider-btn button');

        if ($container.find('.variant-picker__option-values').scrollLeft() <= 0) {
            $prevButton.attr('disabled', true);
        } else {
            $prevButton.attr('disabled', false);
        }

        var widthOfContainer = $container.find('.variant-picker__option-values').innerWidth();
        var widthOfContent = $container.find('.variant-picker__option-values')[0].scrollWidth;

        if ($container.find('.variant-picker__option-values').scrollLeft() + widthOfContainer >= widthOfContent) {
            $nextButton.attr('disabled', true);
        } else {
            $nextButton.attr('disabled', false);
        }
    }

    // Initial check for each container
    $('.mrk-slider-container').each(function() {
        checkScroll($(this));
    });

    // Attach click event to Next button
    $('.mrk-next-slider-btn button').click(function() {
        var $container = $(this).closest('.mrk-slider-container');
        var $content = $container.find('.variant-picker__option-values');
        if(rtl){
        $content.animate({
            scrollLeft: '-=' + scrollAmount
        }, animationSpeed, function() {
            checkScroll($container);
        });
        }else{
          $content.animate({
              scrollLeft: '+=' + scrollAmount
          }, animationSpeed, function() {
              checkScroll($container);
          });
        }
    });

    // Attach click event to Previous button
    $('.mrk-prev-slider-btn button').click(function() {
        var $container = $(this).closest('.mrk-slider-container');
        var $content = $container.find('.variant-picker__option-values');
        if(rtl){
        $content.animate({
            scrollLeft: '+=' + scrollAmount
        }, animationSpeed, function() {
            checkScroll($container);
        });
        }else{
          $content.animate({
              scrollLeft: '-=' + scrollAmount
          }, animationSpeed, function() {
              checkScroll($container);
          });
        }
    });
});